import * as yup from "yup";

import { Translations, i18n } from "@i18n";
import { MaritalStatusFormValues } from "./types";

export const validationSchema: yup.SchemaOf<MaritalStatusFormValues> = yup.object().shape({
  firstName: yup
    .string()
    .required(i18n.t(Translations.MaritalStatusRouteSpouseFirstNameInputRequired)),
  lastName: yup
    .string()
    .required(i18n.t(Translations.MaritalStatusRouteSpouseLastNameInputRequired)),
});
